<template>
  <v-row>
    <v-col sm="6">
      <v-text-field
          v-model="textValue"
          :label="label"
          :maxlength="maxlength"
          type="number"
          :disabled="!!pnValue"
          @keypress="validate"
      />
    </v-col>
    <v-col sm="6">
      <v-autocomplete
          v-model="pnValue"
          label="Pertinent Negatives"
          :items="selectPnItems"
          clearable
      />
    </v-col>
  </v-row>
</template>
<script>
import _ from 'lodash';

export default {
  name: 'NumValuePn',
  props: {
    value: {
      type: [String, Number],
    },
    pn: {
      type: String,
    },
    label: {
      type: String,
    },
    field: {
      type: Object,
      required: true,
    },
  },

  computed: {
    selectPnItems() {
      if (!this.field.pnValues) {
        return null;
      }
      return _.map(this.field.pnValues, (text, code) => ({
        text,
        value: code,
      }));
    },
    textValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    pnValue: {
      get() {
        return this.pn;
      },
      set(value) {
        this.$emit('update:pn', value);
        if (value) {
          this.$emit('input', null);
        }
      },
    },
    maxlength() {
      if (this.field.restrictions && this.field.restrictions.maxlen) {
        return this.field.restrictions.maxlen;
      }
      if (this.field.restrictions && this.field.restrictions.max) {
        return this.field.restrictions.max.toString().length;
      }
      return 255;
    },
  },
  methods: {
    validate($event) {
      if (this.textValue.toString().length === this.maxlength) {
        $event.preventDefault();
      }
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    },
  },
};
</script>
